import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import * as Sentry from '@sentry/react'
import reducers from './reducers'

const reducer = combineReducers({ ...reducers })

const rootReducer = (defaultState, action) => {
  const state = defaultState
  return reducer(state, action)
}

const middlewares = []

const composeEnhancers = typeof window === 'object' &&
   window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    })
  : compose

// Sentry redux enhancer attaches the most recent dispatched actions to any
// captured error as breadcrumbs — so a Sentry issue's dashboard shows the
// "user tapped X → fetched Y → set state Z → crash" trail leading up to
// each event. Stays a no-op when no DSN is configured.
const sentryReduxEnhancer = Sentry.createReduxEnhancer()

export const store = composeEnhancers(
  applyMiddleware(...middlewares),
  sentryReduxEnhancer,
)(createStore)(rootReducer)

export default store
